export default {"src":"/_next/static/media/speed.c7260904.svg","height":138,"width":182};